import React from "react"

const CSS = `
@keyframes hb-pop {
  0%   { transform: scale(.3); opacity: 0; }
  55%  { transform: scale(1.18); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}
@keyframes hb-fade-out {
  0%, 70% { opacity: 1; }
  100%    { opacity: 0; }
}
@keyframes hb-rise {
  0%   { transform: translateY(8px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}
@keyframes hb-shimmer {
  0%   { background-position: -200px 0; }
  100% { background-position: 200px 0; }
}
.hb-shimmer {
  background: linear-gradient(90deg, #f1f5f9 0px, #e2e8f0 60px, #f1f5f9 120px);
  background-size: 400px 100%;
  animation: hb-shimmer 1.2s linear infinite;
}
`

const Animations = () => <style>{CSS}</style>

export default Animations
